import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

const helpContent = {
    en: {
        button: 'How to use Ready Teddy Go',
        title: 'How to use Ready Teddy Go',
        close: 'Close',
        steps: [
            'Choose a scenario, then select videos to add them to the list.',
            'Drag videos to change their order. Double-click a listed video to remove it.',
            'Use Play next for one video or Play sequence for the full list. You can also click the video to start the sequence.',
            'Use the three-dot button on the video to show playback controls.',
            'Double-click the video to enter or leave fullscreen.',
            'Use the green and red buttons to record a reaction.',
        ],
    },
    pl: {
        button: 'Jak korzystać z Ready Teddy Go',
        title: 'Jak korzystać z Ready Teddy Go',
        close: 'Zamknij',
        steps: [
            'Wybierz scenariusz, a następnie filmy, które chcesz dodać do listy.',
            'Przeciągaj filmy, aby zmienić ich kolejność. Kliknij film na liście dwukrotnie, aby go usunąć.',
            'Użyj przycisku Następny film albo Odtwórz sekwencję. Możesz też kliknąć film, aby rozpocząć sekwencję.',
            'Przycisk z trzema kropkami na filmie pokazuje elementy sterujące odtwarzaniem.',
            'Kliknij film dwukrotnie, aby włączyć lub wyłączyć tryb pełnoekranowy.',
            'Zielony i czerwony przycisk służą do zapisania reakcji.',
        ],
    },
    it: {
        button: 'Come usare Ready Teddy Go',
        title: 'Come usare Ready Teddy Go',
        close: 'Chiudi',
        steps: [
            'Scegli uno scenario, poi seleziona i video da aggiungere alla lista.',
            'Trascina i video per cambiarne l’ordine. Fai doppio clic su un video nella lista per rimuoverlo.',
            'Usa Video successivo per un solo video o Riproduci sequenza per l’intera lista. Puoi anche fare clic sul video per avviare la sequenza.',
            'Il pulsante con tre punti sul video mostra i controlli di riproduzione.',
            'Fai doppio clic sul video per attivare o disattivare lo schermo intero.',
            'Usa i pulsanti verde e rosso per registrare una reazione.',
        ],
    },
    es: {
        button: 'Cómo usar Ready Teddy Go',
        title: 'Cómo usar Ready Teddy Go',
        close: 'Cerrar',
        steps: [
            'Elige un escenario y selecciona los vídeos que quieras añadir a la lista.',
            'Arrastra los vídeos para cambiar el orden. Haz doble clic en un vídeo de la lista para eliminarlo.',
            'Usa Reproducir el siguiente para un vídeo o Reproducir secuencia para toda la lista. También puedes hacer clic en el vídeo para iniciar la secuencia.',
            'El botón de tres puntos del vídeo muestra los controles de reproducción.',
            'Haz doble clic en el vídeo para activar o salir de la pantalla completa.',
            'Usa los botones verde y rojo para registrar una reacción.',
        ],
    },
    el: {
        button: 'Πώς χρησιμοποιείται το Ready Teddy Go',
        title: 'Πώς χρησιμοποιείται το Ready Teddy Go',
        close: 'Κλείσιμο',
        steps: [
            'Επίλεξε ένα σενάριο και μετά τα βίντεο που θέλεις να προσθέσεις στη σειρά.',
            'Σύρε τα βίντεο για να αλλάξεις τη σειρά τους. Κάνε διπλό κλικ σε ένα βίντεο της λίστας για να το αφαιρέσεις.',
            'Χρησιμοποίησε το Επόμενο για ένα βίντεο ή την Αναπαραγωγή σειράς για όλη τη λίστα. Μπορείς επίσης να κάνεις κλικ στο βίντεο για να ξεκινήσεις τη σειρά.',
            'Το κουμπί με τις τρεις τελείες στο βίντεο εμφανίζει τα στοιχεία ελέγχου.',
            'Κάνε διπλό κλικ στο βίντεο για είσοδο ή έξοδο από την πλήρη οθόνη.',
            'Χρησιμοποίησε το πράσινο και το κόκκινο κουμπί για να καταγράψεις μια αντίδραση.',
        ],
    },
    lt: {
        button: 'Kaip naudotis Ready Teddy Go',
        title: 'Kaip naudotis Ready Teddy Go',
        close: 'Uždaryti',
        steps: [
            'Pasirinkite scenarijų, tada vaizdo įrašus, kuriuos norite įtraukti į sąrašą.',
            'Vilkite vaizdo įrašus, kad pakeistumėte jų tvarką. Dukart spustelėkite sąrašo įrašą, kad jį pašalintumėte.',
            'Pasirinkite kitą vaizdo įrašą arba paleiskite visą seką. Seką taip pat galite pradėti spustelėję vaizdo įrašą.',
            'Trijų taškų mygtukas vaizdo įraše parodo atkūrimo valdiklius.',
            'Dukart spustelėkite vaizdo įrašą, kad įjungtumėte arba išjungtumėte viso ekrano režimą.',
            'Žalias ir raudonas mygtukai skirti reakcijai pažymėti.',
        ],
    },
};

export default function UsageHelp({ lang }) {
    const [show, setShow] = useState(false);
    const content = helpContent[lang] || helpContent.en;

    return (
        <>
            <button
                className='helpButton'
                type='button'
                aria-label={content.button}
                title={content.button}
                onClick={() => setShow(true)}
            >
                i
            </button>

            <Modal className='usageHelpModal' show={show} onHide={() => setShow(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{content.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ol>
                        {content.steps.map(step => <li key={step}>{step}</li>)}
                    </ol>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='primary' onClick={() => setShow(false)}>{content.close}</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
